import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ValorationActions } from "./valoration.action.types";
import { map, mergeMap } from "rxjs";
import { ValorationService } from '../../services/valoration.service';
import { AssessmentService } from "@app/services/assessment.service";

@Injectable()
export class ValorationEffects {
  
  getPragmaPowersCategories$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValorationActions.loadPragmaPowerCategories),
      mergeMap((r) => {
        return this.valorationService.getPragmaPowerCategories(r.pragmaPowerRequest).pipe(
          map((result) => 
          ValorationActions.loadPragmaPowerCategoriesSuccess({
              pragmaPowerCategories:result
            })
          )
        )
      })
    )
  })

  getPragmaPowersDefinition$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValorationActions.loadPragmaPowerDefinition ),
      mergeMap((r) => {
        return this.valorationService.getPragmaPowerDefinition(r.pragmaPowerDefinitionRequest).pipe(
          map((result) => 
          ValorationActions.loadPragmaPowerDefinitionSuccess({
            pragmaPowerDefinition:result
            })
          )
        )
      })
    )
  })

  getLastValoration$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValorationActions.loadLastValoration ),
      mergeMap((request) => {
        const { lastValorationRequest } = request
        return this.assessmentService.getLastValoration(lastValorationRequest).pipe(
          map((result) => {
            return ValorationActions.loadLastValorationSuccess({
              lastValoration: result || undefined
            })
          })
        )
      })
    )
  })

  getApprovedAssessment$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValorationActions.loadApprovedAssessment ),
      mergeMap((r) => {
        return this.assessmentService.getOverview(r.approvedAssessmentRequest.email, r.approvedAssessmentRequest.status, r.approvedAssessmentRequest.chapterName, r.approvedAssessmentRequest.selfAssessed, r.approvedAssessmentRequest.pragmapowerType).pipe(
          map((result) => 
          ValorationActions.loadApprovedAssessmentSuccess({
              approvedAssessment: result || null
            })
          )
        )
      })
    )
  })

  getRejectedAssessment$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValorationActions.loadRejectedAssessment ),
      mergeMap((r) => {
        return this.assessmentService.getOverview(r.rejectedAssessmentRequest.email, r.rejectedAssessmentRequest.status, r.rejectedAssessmentRequest.chapterName, r.rejectedAssessmentRequest.selfAssessed, r.rejectedAssessmentRequest.pragmapowerType).pipe(
          map((result) => 
          ValorationActions.loadRejectedAssessmentSuccess({
              rejectedAssessment: result || null
            })
          )
        )
      })
    )
  })

  getPendingAssessment$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValorationActions.loadPendingAssessment ),
      mergeMap((r) => {
        return this.assessmentService.getOverview(r.pendingAssessmentRequest.email, r.pendingAssessmentRequest.status, r.pendingAssessmentRequest.chapterName, r.pendingAssessmentRequest.selfAssessed, r.pendingAssessmentRequest.pragmapowerType).pipe(
          map((result) => 
          ValorationActions.loadPendingAssessmentSuccess({
              pendingAssessment: result || null
            })
          )
        )
      })
    )
  })

  getStartedAssessment$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValorationActions.loadStartedAssessment ),
      mergeMap((r) => {
        return this.assessmentService.getOverview(r.startedAssessmentRequest.email, r.startedAssessmentRequest.status, r.startedAssessmentRequest.chapterName, r.startedAssessmentRequest.selfAssessed, r.startedAssessmentRequest.pragmapowerType).pipe(
          map((result) => 
          ValorationActions.loadStartedAssessmentSuccess({
              startedAssessment: result || null
            })
          )
        )
      })
    )
  })

  getFinalizedAutoassessment$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValorationActions.loadFinalizedAutoassessment ),
      mergeMap((request) => {
        return this.assessmentService.getOverview(request.finalizedAutoassessmentRequest.email, request.finalizedAutoassessmentRequest.status, request.finalizedAutoassessmentRequest.chapterName, request.finalizedAutoassessmentRequest.selfAssessed, request.finalizedAutoassessmentRequest.pragmapowerType).pipe(
          map((result) => 
          ValorationActions.loadFinalizedAutoassessmentSuccess({
              finalizedAutoassessment: result || null
            })
          )
        )
      })
    )
  })

  getStartedAutoassessment$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValorationActions.loadStartedAutoassessment ),
      mergeMap((request) => {
        return this.assessmentService.getOverview(request.startedAutoassessmentRequest.email, request.startedAutoassessmentRequest.status, request.startedAutoassessmentRequest.chapterName, request.startedAutoassessmentRequest.selfAssessed, request.startedAutoassessmentRequest.pragmapowerType).pipe(
          map((result) => 
          ValorationActions.loadStartedAutoassessmentSuccess({
              startedAutoassessment: result || null
            })
          )
        )
      })
    )
  })



  constructor( private actions$: Actions,
               private valorationService: ValorationService,
               private assessmentService: AssessmentService

              ) {
    
  }
}